import { useTimeAgo } from "../hooks/useTimeAgo";

export const getStatusColor = (status) => {
  switch (status) {
    case "Dispatched":
    case "Completed":
    case "Uploaded":
    case "Sent":
    case "Received":
    case "online":
    case "Ready For Dispatch":
      return "#31974D";

    case "Dispatched Pending":
    case "POD Pending":
    case "Pending":
    case "Payment Under Verification":
    case "In Progress":
    case "Partner Pending":
    case "Cash Pending at Partner":
    case "Cash Pending at Collector":
    case "Pending For Refund":
    case "Pending For Verification":
    case "In Production":
      return "#FF9B04";

    case "Packing In Progress":
    case "Packed":
      return "#9747FF";

    case "Payment Pending":
    case "Delivery Pending":
    case "Cancelled":
    case "Urgent":
    case "Closed":
      return "#F93E3E";

    case "New Order":
    case "New":
      return "#7698FF";

    default:
      return "";
  }
};

export const getMinDate = () => {
  const today = new Date();
  const currentYear = today.getFullYear();

  const financialYearStart = new Date(
    today.getMonth() < 3 ? currentYear - 1 : currentYear,
    3,
    1,
  );

  const minDate = financialYearStart.toISOString().split("T")[0];

  return minDate;
};

export const formatDateTime = (input) => {
  if (!input || input === "") return "";

  let date;
  let includeTime = true;

  if (/^\d{2}-\d{2}-\d{4}$/.test(input)) {
    const [day, month, year] = input.split("-").map(Number);
    date = new Date(year, month - 1, day);
    includeTime = false;
  } else {
    date = new Date(input);
  }

  if (isNaN(date.getTime())) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  if (!includeTime) {
    return `${day} ${month} ${year}`;
  }

  const time = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${time}, ${day} ${month} ${year}`;
};

export const handleViewImage = (image) => {
  if (image) {
    const imageUrl =
      image instanceof File || image instanceof Blob
        ? URL.createObjectURL(process.env.REACT_APP_S3URL + image)
        : process.env.REACT_APP_S3URL + image;

    window.open(
      imageUrl,
      "ImageViewer",
      "width=800,height=600,scrollbars=yes,resizable=yes",
    );
  }
};

export function LastActionCell({ lastAction }) {
  const timeAgo = useTimeAgo(lastAction);
  return <span title={timeAgo}>{timeAgo}</span>;
}
